import SpendSvg from "components/svg/Bids/spend";
import RetailerSvg from "components/svg/Bids/retailers";
import VistiorsSvg from "components/svg/Bids/visitors";
import FootfallSvg from "components/svg/Bids/footfall";
import SpendSvg2 from "components/svg/Bids/spend2";
import styles from "./snapshot.module.css";
import global from '../bid.module.css';

type Props = {
  metrics: [
    {
      value: string,
      units: string,
      label: string,
      lineart: string
    }
  ],
  theme: {
    secondaryImage: string,
    primary: string,
    primaryHeading: string,
    secondaryHeading: string,
    secondaryText: string,
    primaryText: string,
    secondary: string
  },
}

const Snapshot = ({ metrics, theme }: Props) => (
  <div className={`${styles.Container} ${global.Container}`} id="metrics">
    <ul className={styles.Metrics}>
      {metrics.map(({ value, units, label, lineart }, index) => {
        return (
          <li className={styles.MetricsLi} key={`${value}_${label}`} style={{ backgroundColor: index === 1 ? theme.primary : theme.secondary }}>
            <div className={styles.metricsContainer}>
              <div className={styles.imageContainer}>
                {lineart === 'spend' && (
                  <SpendSvg primary={theme.primary} secondary={theme.secondaryImage} />
                )}

                {lineart === 'retailers' && (
                  <RetailerSvg primary={theme.secondaryImage} secondary={theme.secondary} />
                )}

                {lineart === 'visitors' && (
                  <VistiorsSvg primary={theme.primary} secondary={theme.secondaryImage} />
                )}
                {lineart === 'footfall' && (
                  <FootfallSvg primary={theme.primary} secondary={theme.secondaryImage} />
                )}
                {lineart === 'spend2' && (
                  <SpendSvg2 primary={theme.primary} secondary={theme.secondaryImage} />
                )}
              </div>
              <h4 style={{ color: index === 1 ? theme.primaryHeading : theme.secondaryHeading }}>
                <span>{value}</span>
                {units}
              </h4>
              <p style={{ color: index === 1 ? theme.secondaryText : theme.primaryText }}>{label}</p>
            </div>
          </li>
        )
      })}
    </ul>
  </div>
);

export default Snapshot;